import GroupsList from '@Groups/views/GroupsList.vue';
import permissions from '../Share/config/permissions';

export default [
  {
    path: '/manage-facilities-groups',
    name: 'groups',
    component: GroupsList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Groups',
      permissions: [permissions.Facilities.View]
    },
  },
];
